const o = {
  ArrowDownIcon: () => import("@toruslabs/vue-icons/arrows/ArrowDownIcon"),
  ChevronDownIcon: () => import("@toruslabs/vue-icons/arrows/ChevronDownIcon"),
  SearchIcon: () => import("@toruslabs/vue-icons/maps/SearchIcon"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  ExclamationCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/ExclamationCircleSolidIcon"),
  ExclamationCircleIcon: () => import("@toruslabs/vue-icons/notifications/ExclamationCircleIcon"),
  CheckCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/CheckCircleSolidIcon"),
  CogSolidIcon: () => import("@toruslabs/vue-icons/others/CogSolidIcon"),
  QuestionMarkCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/QuestionMarkCircleSolidIcon")
};
export {
  o as default
};
